// src/api/index.js
import axios from "axios";
import setupInterceptors from "./interceptors";

const api = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
    accept: "application/json",
  },
});

// Injecte token + gestion erreurs
setupInterceptors(api);

export default api;
